// Attribution: This utility function is inspired by shadcn's work.

// biome-ignore lint/style/noRestrictedImports: cn wraps clsx
import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Combines class names using `clsx` and merges Tailwind CSS classes using
 * `tailwind-merge`.
 *
 * @param inputs - One or more `ClassValue` arguments (strings, objects, arrays,
 *   or falsy values).
 * @returns A single string of combined and merged class names.
 *
 * @example
 * ```tsx
 * const combinedClasses = cn('class1', 'class2', condition && 'conditionalClass');
 * ```
 */
const cn = (...inputs: ClassValue[]) => {
  return twMerge(clsx(inputs));
};

export type { ClassValue };
export default cn;
